(function () {
  'use strict';

  var FINISHING_KEYS = ['hemmed', 'grommets', 'hemmed_and_grommets', 'none'];
  var POLE_POCKET_KEYS = ['none', 'top', 'bottom', 'top_bottom', 'left', 'right', 'left_right'];
  var URL_FINISHING_VALUES = {
    none: 'none',
    hemmed: 'hemmed',
    grommets: 'grommets',
    hemmed_and_grommets: 'hemmed-grommets'
  };
  var URL_POLE_POCKET_VALUES = {
    none: 'none',
    top: 'top',
    bottom: 'bottom',
    top_bottom: 'top-bottom',
    left: 'left',
    right: 'right',
    left_right: 'left-right'
  };

  function number(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function trimNumber(value, places) {
    return Number(value.toFixed(places)).toString();
  }

  function currency(value, code) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function configUid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return 'banner-' + window.crypto.randomUUID();
    return 'banner-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function canonicalKey(value) {
    return String(value || '').trim().toLowerCase().replace(/-/g, '_');
  }

  function formatDimension(totalInches) {
    var feet = Math.floor(totalInches / 12);
    var inches = totalInches - feet * 12;
    var inchText = trimNumber(inches, 2);
    if (feet > 0 && Math.abs(inches) < 1e-9) return feet + '′';
    if (feet > 0) return feet + '′ ' + inchText + '″';
    return trimNumber(totalInches, 2) + '″';
  }

  function sizeLabel(widthInches, heightInches) {
    return formatDimension(widthInches) + ' × ' + formatDimension(heightInches);
  }

  function focusableElements(container) {
    return Array.from(container.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function variantRecipeResponseError(response, fallback) {
    return response.json()
      .catch(function () { return {}; })
      .then(function (payload) {
        throw new Error(payload.description || payload.message || fallback);
      });
  }

  function variantRecipeProperties(form) {
    var properties = {};
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (!match || (typeof File !== 'undefined' && value instanceof File)) return;
      if (String(value).trim() !== '') properties[match[1]] = String(value);
    });
    return properties;
  }

  function variantRecipeRefreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed.');
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.setTimeout(function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
        }, 300);
      });
  }

  function initializeVariantRecipe(root) {
    var form = document.getElementById(root.dataset.formId);
    var modal = document.getElementById(root.dataset.modalId);
    var status = root.querySelector('[data-zug-banner-status]');
    var submitButton = root.querySelector('[data-zug-banner-submit]');
    var quantityInput = root.querySelector('[data-zug-banner-quantity-input]');
    var quantityMinus = root.querySelector('[data-zug-banner-quantity-minus]');
    var quantityPlus = root.querySelector('[data-zug-banner-quantity-plus]');
    var tierQuantityDisplay = root.querySelector('[data-zug-banner-tier-quantity-display]');
    var quantityError = root.querySelector('[data-zug-banner-quantity-error]');
    var optionGroups = Array.from(root.querySelectorAll('[data-zug-banner-variant-group]'));
    var addonTriggers = Array.from(root.querySelectorAll('[data-zug-banner-addon-trigger]'));
    var turnaroundValue = root.querySelector('[data-zug-banner-turnaround-value]');
    var turnaroundButtons = Array.from(root.querySelectorAll('[data-zug-banner-choice-group="turnaround"] [data-value]'));
    var optionScript = root.querySelector('[data-zug-banner-variant-options]');
    var variantScript = root.querySelector('[data-zug-banner-variants]');
    var constraintsScript = root.querySelector('[data-zug-banner-variant-constraints]');
    var options = [];
    var variants = [];
    var constraints = {};
    var adjustmentVariants = null;
    var isSubmitting = false;
    var recipeTitle = root.dataset.recipeTitle || 'banner product';
    var quantityMode = root.dataset.quantityMode === 'variant-tier' ? 'variant-tier' : 'line-item';

    try {
      options = JSON.parse(optionScript ? optionScript.textContent : '[]');
      variants = JSON.parse(variantScript ? variantScript.textContent : '[]');
      constraints = JSON.parse(constraintsScript ? constraintsScript.textContent : '{}');
    } catch (error) {
      options = [];
      variants = [];
      constraints = {};
    }

    function normalizedOptionName(value) {
      return String(value || '').trim().toLowerCase();
    }

    function optionIndex(optionName) {
      var normalizedName = normalizedOptionName(optionName);
      return options.findIndex(function (name) {
        return normalizedOptionName(name) === normalizedName;
      });
    }

    var nativeTurnaroundOption = String(root.dataset.nativeTurnaroundOption || '').trim();
    var requiresNativeTurnaround = nativeTurnaroundOption !== '';
    var nativeTurnaroundOptionIndex = requiresNativeTurnaround ? optionIndex(nativeTurnaroundOption) : -1;
    var nativeTurnaroundValues = {
      regular: String(root.dataset.nativeTurnaroundRegular || '').trim(),
      rush_3_5: String(root.dataset.nativeTurnaroundRushThreeFive || '').trim(),
      rush_1_2: String(root.dataset.nativeTurnaroundRushOneTwo || '').trim()
    };
    var nativeTurnaroundReady = !requiresNativeTurnaround || (
      nativeTurnaroundOptionIndex !== -1 &&
      Object.keys(nativeTurnaroundValues).every(function (key) {
        var expectedValue = nativeTurnaroundValues[key];
        return expectedValue !== '' && variants.some(function (variant) {
          return variant.options[nativeTurnaroundOptionIndex] === expectedValue;
        });
      })
    );

    var groupConfigs = optionGroups.map(function (group) {
      return {
        element: group,
        optionName: group.dataset.optionName || '',
        optionIndex: optionIndex(group.dataset.optionName),
        summaryKey: group.dataset.summaryKey || '',
        propertyName: group.dataset.propertyName || '',
        valueElement: root.querySelector('[data-zug-banner-variant-value="' + (group.dataset.summaryKey || '') + '"]'),
        buttons: Array.from(group.querySelectorAll('[data-zug-banner-variant-option]'))
      };
    });

    var addonModalConfigs = addonTriggers.map(function (trigger) {
      var modal = document.getElementById(trigger.getAttribute('aria-controls'));
      var cards = modal ? Array.from(modal.querySelectorAll('[data-zug-banner-modal-option]')) : [];
      return {
        trigger: trigger,
        modal: modal,
        cards: cards,
        apply: modal && modal.querySelector('[data-zug-banner-addon-apply]'),
        summary: modal && modal.querySelector('[data-zug-banner-addon-modal-summary]'),
        closeButtons: modal ? Array.from(modal.querySelectorAll('[data-zug-banner-addon-close]')) : [],
        tempAddons: {},
        opener: null
      };
    });
    var addonConfigs = [];
    addonModalConfigs.forEach(function (modalConfig) {
      var groupKeys = [];
      modalConfig.cards.forEach(function (card) {
        if (groupKeys.indexOf(card.dataset.group) === -1) groupKeys.push(card.dataset.group);
      });
      groupKeys.forEach(function (key) {
        var cards = modalConfig.cards.filter(function (card) { return card.dataset.group === key; });
        var selectedCard = cards.find(function (card) { return card.classList.contains('is-selected'); }) || cards[0];
        addonConfigs.push({
          key: key,
          modal: modalConfig.modal,
          cards: cards,
          selectedKey: selectedCard ? selectedCard.dataset.key : ''
        });
      });
    });

    function buttonValue(button) {
      return button ? button.dataset.optionValue : '';
    }

    function selectedButton(buttons) {
      return buttons.find(function (button) { return button.classList.contains('is-selected'); }) || buttons[0];
    }

    var initialVariantId = Number(root.dataset.selectedVariantId);
    var initialVariant = variants.find(function (variant) {
      return Number(variant.id) === initialVariantId;
    }) || variants.find(function (variant) { return variant.available; }) || variants[0];

    var initialSelections = {};
    groupConfigs.forEach(function (groupConfig) {
      initialSelections[groupConfig.optionName] = initialVariant && groupConfig.optionIndex !== -1
        ? initialVariant.options[groupConfig.optionIndex]
        : buttonValue(selectedButton(groupConfig.buttons));
    });

    function nativeTurnaroundKey(value) {
      return Object.keys(nativeTurnaroundValues).find(function (key) {
        return nativeTurnaroundValues[key] === value;
      }) || '';
    }

    var initialTurnaround = 'regular';
    if (requiresNativeTurnaround && initialVariant && nativeTurnaroundOptionIndex !== -1) {
      initialTurnaround = nativeTurnaroundKey(initialVariant.options[nativeTurnaroundOptionIndex]) || 'regular';
      initialSelections[nativeTurnaroundOption] = nativeTurnaroundValues[initialTurnaround];
    }
    var initialTurnaroundButton = turnaroundButtons.find(function (button) {
      return button.dataset.value === initialTurnaround;
    });

    var initialAddons = {};
    addonConfigs.forEach(function (addonConfig) {
      initialAddons[addonConfig.key] = addonConfig.selectedKey;
    });

    var state = {
      selections: initialSelections,
      addons: initialAddons,
      quantity: 1,
      turnaround: initialTurnaround,
      turnaroundLabel: initialTurnaroundButton
        ? initialTurnaroundButton.dataset.label
        : (turnaroundValue ? turnaroundValue.textContent.trim() : 'Regular'),
      turnaroundMultiplier: initialTurnaround === 'rush_3_5' ? 1.2 : (initialTurnaround === 'rush_1_2' ? 1.5 : 1),
      artworkMode: '',
      artworkLabel: 'Choose an artwork option',
      selectedVariant: initialVariant || null,
      pricingMetrics: null,
      configUid: configUid()
    };

    turnaroundButtons.forEach(function (button) {
      var selected = button.dataset.value === state.turnaround;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    if (turnaroundValue) turnaroundValue.textContent = state.turnaroundLabel;

    function setStatus(message, isError) {
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function propertyInput(name) {
      return form.querySelector('[data-property="' + name + '"]');
    }

    function setProperty(name, value) {
      var input = propertyInput(name);
      if (input) input.value = value == null ? '' : String(value);
    }

    function labelFor(groupConfig, value) {
      var button = groupConfig.buttons.find(function (candidate) {
        return candidate.dataset.optionValue === value;
      });
      return button ? button.dataset.label : value;
    }

    function addonCard(addonConfig, key) {
      return addonConfig.cards.find(function (card) { return card.dataset.key === key; }) || null;
    }

    function addonPropertyName(key) {
      if (key === 'carry_bag') return 'Carry Bag';
      return key.charAt(0).toUpperCase() + key.slice(1);
    }

    function addonAdjustmentCents() {
      return addonConfigs.reduce(function (total, addonConfig) {
        var card = addonCard(addonConfig, state.addons[addonConfig.key]);
        return total + (card ? number(card.dataset.adjustmentCents, 0) : 0);
      }, 0);
    }

    function renderAddonModal(modalConfig) {
      modalConfig.cards.forEach(function (card) {
        var selected = card.dataset.key === modalConfig.tempAddons[card.dataset.group];
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (modalConfig.summary) {
        modalConfig.summary.textContent = addonConfigs
          .filter(function (addonConfig) { return addonConfig.modal === modalConfig.modal; })
          .map(function (addonConfig) {
            var selectedCard = addonCard(addonConfig, modalConfig.tempAddons[addonConfig.key]);
            return selectedCard ? selectedCard.dataset.label : '';
          })
          .filter(Boolean)
          .join(' · ');
      }
    }

    function closeAddonModal(modalConfig) {
      if (!modalConfig.modal) return;
      modalConfig.modal.hidden = true;
      modalConfig.modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      addonConfigs.forEach(function (addonConfig) {
        if (addonConfig.modal === modalConfig.modal) {
          modalConfig.tempAddons[addonConfig.key] = state.addons[addonConfig.key];
        }
      });
      renderAddonModal(modalConfig);
      if (modalConfig.opener && typeof modalConfig.opener.focus === 'function') modalConfig.opener.focus();
    }

    function openAddonModal(modalConfig) {
      if (!modalConfig.modal) return;
      modalConfig.opener = modalConfig.trigger;
      addonConfigs.forEach(function (addonConfig) {
        if (addonConfig.modal === modalConfig.modal) {
          modalConfig.tempAddons[addonConfig.key] = state.addons[addonConfig.key];
        }
      });
      renderAddonModal(modalConfig);
      modalConfig.modal.hidden = false;
      modalConfig.modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var selected = modalConfig.cards.find(function (card) { return card.classList.contains('is-selected'); });
      (selected || focusableElements(modalConfig.modal)[0]).focus();
    }

    function variantForSelections(selections) {
      return variants.find(function (variant) {
        return options.every(function (optionName, index) {
          var expectedValue = Object.prototype.hasOwnProperty.call(constraints, optionName)
            ? constraints[optionName]
            : selections[optionName];
          if (expectedValue == null || expectedValue === '') {
            return initialVariant && variant.options[index] === initialVariant.options[index];
          }
          return variant.options[index] === expectedValue;
        });
      }) || null;
    }

    function setButtonState(groupConfig) {
      groupConfig.buttons.forEach(function (button) {
        var candidateSelections = Object.assign({}, state.selections);
        candidateSelections[groupConfig.optionName] = button.dataset.optionValue;
        var candidateVariant = variantForSelections(candidateSelections);
        var selectedValue = state.selections[groupConfig.optionName];
        var selected = button.dataset.optionValue === selectedValue;
        var available = Boolean(candidateVariant && candidateVariant.available);

        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.disabled = !available;
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    }

    function selectedTierQuantity() {
      var quantityGroup = groupConfigs.find(function (groupConfig) {
        return groupConfig.summaryKey === 'quantity';
      });
      if (!quantityGroup) return NaN;
      var selectedValue = state.selections[quantityGroup.optionName];
      var button = quantityGroup.buttons.find(function (candidate) {
        return candidate.dataset.optionValue === selectedValue;
      });
      return Number(button ? (button.dataset.tierQuantity || button.dataset.optionValue) : selectedValue);
    }

    function tierButtonForQuantity(quantity) {
      var quantityGroup = groupConfigs.find(function (groupConfig) {
        return groupConfig.summaryKey === 'quantity';
      });
      if (!quantityGroup) return null;
      return quantityGroup.buttons.reduce(function (selected, button) {
        var buttonQuantity = Number(button.dataset.tierQuantity || button.dataset.optionValue);
        if (button.disabled || !Number.isInteger(buttonQuantity) || buttonQuantity > quantity) return selected;
        if (!selected) return button;
        var selectedQuantity = Number(selected.dataset.tierQuantity || selected.dataset.optionValue);
        return buttonQuantity > selectedQuantity ? button : selected;
      }, null);
    }

    function normalizedQuantity() {
      if (quantityMode === 'variant-tier') {
        var displayQuantity = Number(tierQuantityDisplay ? tierQuantityDisplay.value : NaN);
        var quantityValid = Number.isInteger(displayQuantity) && displayQuantity >= 1;
        var tierButton = quantityValid ? tierButtonForQuantity(displayQuantity) : null;
        var tierValid = Boolean(tierButton);
        if (tierButton) {
          var quantityGroup = groupConfigs.find(function (groupConfig) {
            return groupConfig.summaryKey === 'quantity';
          });
          state.selections[quantityGroup.optionName] = tierButton.dataset.optionValue;
        }
        quantityInput.value = '1';
        if (tierQuantityDisplay) {
          tierQuantityDisplay.style.setProperty(
            '--quantity-input-characters-count',
            Math.max(String(tierQuantityDisplay.value || '1').length, 1) + 'ch'
          );
          tierQuantityDisplay.setAttribute('aria-invalid', tierValid ? 'false' : 'true');
        }
        quantityError.textContent = tierValid ? '' : 'Quantity must be a whole number of at least 1.';
        if (quantityMinus) quantityMinus.disabled = !tierValid || displayQuantity <= 1;
        if (quantityPlus) quantityPlus.disabled = !tierValid;
        state.quantity = 1;
        state.displayQuantity = tierValid ? displayQuantity : 0;
        return tierValid;
      }

      var value = Number(quantityInput.value);
      var valid = Number.isInteger(value) && value >= 1;
      quantityInput.style.setProperty(
        '--quantity-input-characters-count',
        Math.max(String(quantityInput.value || '1').length, 1) + 'ch'
      );
      quantityInput.setAttribute('aria-invalid', valid ? 'false' : 'true');
      quantityError.textContent = valid ? '' : 'Quantity must be a whole number of at least 1.';
      if (quantityMinus) quantityMinus.disabled = valid && value <= 1;
      if (valid) {
        state.quantity = value;
        state.displayQuantity = value;
      }
      return valid;
    }

    function adjustTierQuantity(direction) {
      if (quantityMode !== 'variant-tier') return;
      var currentQuantity = Number(tierQuantityDisplay ? tierQuantityDisplay.value : NaN);
      if (!Number.isInteger(currentQuantity) || currentQuantity < 1) currentQuantity = 1;
      tierQuantityDisplay.value = String(Math.max(1, currentQuantity + direction));
      render();
    }

    function variantTierBaseCents(variant) {
      var variantPriceCents = Number(variant.price);
      if (quantityMode !== 'variant-tier') return variantPriceCents;
      var tierQuantity = selectedTierQuantity();
      if (!Number.isInteger(tierQuantity) || tierQuantity < 1 || state.displayQuantity === tierQuantity) {
        return variantPriceCents;
      }
      var quantityGroup = groupConfigs.find(function (groupConfig) {
        return groupConfig.summaryKey === 'quantity';
      });
      var maximumTier = quantityGroup
        ? quantityGroup.buttons.reduce(function (maximum, button) {
          return Math.max(maximum, Number(button.dataset.tierQuantity || button.dataset.optionValue) || 0);
        }, 0)
        : 0;
      var overflowUnitCents = number(root.dataset.tierOverflowUnitCents, NaN);
      if (tierQuantity === maximumTier && state.displayQuantity > maximumTier &&
          Number.isInteger(overflowUnitCents) && overflowUnitCents >= 0) {
        return state.displayQuantity * overflowUnitCents;
      }
      return Math.round(variantPriceCents * state.displayQuantity / tierQuantity);
    }

    function updateVariantUrl(variant) {
      if (!variant || !window.history || typeof window.history.replaceState !== 'function') return;
      var destination = new URL(window.location.href);
      destination.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', destination.pathname + destination.search + destination.hash);
    }

    function updateInstallmentVariant(variant) {
      var productInfo = root.closest('.zug-banner-product-info');
      var installmentInput = productInfo && productInfo.querySelector('payment-terms form [name="id"]');
      if (installmentInput && variant) installmentInput.value = String(variant.id);
    }

    function updateVariantRecipeTimeline() {
      var timeline = document.getElementById('ptl-' + root.id.replace('zug-banner-calculator-', '') + '-banner-calc');
      if (!timeline || typeof timeline.ptlSetRange !== 'function') return;
      if (!timeline.dataset.zugRegularMinDays) {
        timeline.dataset.zugRegularMinDays = timeline.dataset.minDays || '7';
        timeline.dataset.zugRegularMaxDays = timeline.dataset.maxDays || '10';
      }
      var min = Number(timeline.dataset.zugRegularMinDays) || 7;
      var max = Number(timeline.dataset.zugRegularMaxDays) || 10;
      if (state.turnaround === 'rush_3_5') {
        min = 3;
        max = 5;
      } else if (state.turnaround === 'rush_1_2') {
        min = 1;
        max = 2;
      }
      timeline.ptlSetRange(min, max);
    }

    function render() {
      var quantityValid = normalizedQuantity();
      var recipeReady = root.dataset.recipeReady === 'true' &&
        nativeTurnaroundReady &&
        groupConfigs.every(function (groupConfig) {
          return groupConfig.optionIndex !== -1 && groupConfig.buttons.length > 0;
        }) &&
        addonConfigs.every(function (addonConfig) {
          return Boolean(
            addonConfig.key &&
            addonConfig.modal &&
            addonConfig.cards.length > 0 &&
            addonConfig.cards.every(function (card) {
              return Number.isFinite(Number(card.dataset.adjustmentCents));
            })
          );
        });
      var variant = recipeReady ? variantForSelections(state.selections) : null;
      var variantAvailable = Boolean(variant && variant.available);
      var currencyCode = root.dataset.currency || 'USD';
      var addOnCents = addonAdjustmentCents();
      var pricingMetrics = null;
      if (variant && quantityValid && window.ZugBannerPricing) {
        try {
          pricingMetrics = window.ZugBannerPricing.variantRecipeMetrics({
            variantPriceCents: variantTierBaseCents(variant),
            addonCents: addOnCents,
            orderQuantity: state.quantity,
            tierQuantity: state.displayQuantity,
            turnaroundMultiplier: requiresNativeTurnaround ? 1 : state.turnaroundMultiplier,
            quantityMode: quantityMode
          });
        } catch (error) {
          pricingMetrics = null;
        }
      }
      var totalCents = pricingMetrics ? pricingMetrics.totalCents : 0;
      var unitPrice = pricingMetrics ? pricingMetrics.priceEachCents / 100 : 0;

      state.selectedVariant = variant;
      state.pricingMetrics = pricingMetrics;
      groupConfigs.forEach(function (groupConfig) {
        var selectedValue = state.selections[groupConfig.optionName];
        var selectedLabel = labelFor(groupConfig, selectedValue);
        var summaryElement = root.querySelector('[data-recipe-summary="' + groupConfig.summaryKey + '"]');
        setButtonState(groupConfig);
        if (groupConfig.valueElement) groupConfig.valueElement.textContent = selectedLabel;
        if (summaryElement) summaryElement.textContent = selectedLabel;
        if (groupConfig.propertyName) setProperty(groupConfig.propertyName, selectedLabel);
      });
      addonConfigs.forEach(function (addonConfig) {
        var selectedCard = addonCard(addonConfig, state.addons[addonConfig.key]);
        var selectedLabel = selectedCard ? selectedCard.dataset.label : '';
        var summaryElement = root.querySelector('[data-recipe-summary="' + addonConfig.key + '"]');
        if (summaryElement) summaryElement.textContent = selectedLabel;
        setProperty(addonPropertyName(addonConfig.key), selectedLabel);
        setProperty('_banner_' + addonConfig.key + '_key', state.addons[addonConfig.key]);
      });
      var addonSummary = root.querySelector('[data-recipe-summary="flag_options"]');
      if (addonSummary) {
        addonSummary.textContent = addonConfigs.map(function (addonConfig) {
          var selectedCard = addonCard(addonConfig, state.addons[addonConfig.key]);
          return selectedCard ? selectedCard.dataset.label : '';
        }).filter(Boolean).join(' · ');
      }

      var configurationSummary = root.querySelector('[data-recipe-summary="configuration"]');
      if (configurationSummary && variant) {
        configurationSummary.textContent = variant.public_title || variant.title || root.dataset.fixedConfiguration || 'Standard';
      }
      root.querySelector('[data-recipe-summary="production"]').textContent = state.turnaroundLabel;
      root.querySelector('[data-recipe-summary="artwork"]').textContent = state.artworkLabel;
      root.querySelector('[data-recipe-summary="quantity"]').textContent =
        quantityValid ? String(state.displayQuantity) : '—';
      root.querySelector('[data-recipe-summary="priceEach"]').textContent =
        variant ? currency(unitPrice, currencyCode) : 'Unavailable';
      root.querySelector('[data-recipe-summary="totalPrice"]').textContent =
        variant && quantityValid ? currency(totalCents / 100, currencyCode) : 'Unavailable';

      if (configurationSummary && variant) {
        setProperty('Configuration', configurationSummary.textContent);
      }
      setProperty('Production', state.turnaroundLabel);
      setProperty('Turnaround', state.turnaroundLabel);
      setProperty('_banner_turnaround_key', state.turnaround);
      setProperty('calc_line_uid', state.configUid);
      setProperty('_calc_line_uid', state.configUid);
      setProperty('_bundle_display_quantity', pricingMetrics ? pricingMetrics.displayQuantity : '');
      if (quantityMode === 'variant-tier') setProperty('Quantity', state.displayQuantity);
      setProperty('_banner_expected_total_cents', totalCents);
      setProperty('_total_desired', (totalCents / 100).toFixed(2));
      setProperty('_banner_addon_cents', addOnCents);
      if (variant) {
        form.querySelector('[name="id"]').value = String(variant.id);
        updateInstallmentVariant(variant);
        updateVariantUrl(variant);
      }

      if (!recipeReady) {
        setStatus(root.dataset.recipeReadyError || 'This product’s Shopify options could not be resolved.', true);
      } else if (!variant) {
        setStatus('This configuration could not be resolved to a Shopify variant.', true);
      } else if (!variant.available) {
        setStatus('This configuration is currently unavailable.', true);
      } else if (!quantityValid) {
        setStatus('Enter a valid quantity before continuing.', true);
      } else if (!pricingMetrics) {
        setStatus('This configuration could not be priced safely.', true);
      } else if (!requiresNativeTurnaround && !adjustmentVariants) {
        setStatus('Loading turnaround pricing…');
      } else if (!isSubmitting) {
        setStatus('');
      }

      var pricingContractReady = requiresNativeTurnaround ? nativeTurnaroundReady : Boolean(adjustmentVariants);
      submitButton.disabled = isSubmitting || !recipeReady || !variantAvailable || !quantityValid ||
        !pricingMetrics || !pricingContractReady;
      return recipeReady && variantAvailable && quantityValid && Boolean(pricingMetrics) && pricingContractReady;
    }

    function buildVariantRecipeBundle() {
      var variant = state.selectedVariant;
      var pricingMetrics = state.pricingMetrics;
      if (!variant || !pricingMetrics) {
        throw new Error('Variant recipe pricing is incomplete.');
      }
      if (requiresNativeTurnaround) {
        if (!nativeTurnaroundReady || Number(variant.price) * pricingMetrics.cartQuantity !== pricingMetrics.totalCents) {
          throw new Error('The native Step and Repeat price does not match the configured total.');
        }
        return {
          items: [{
            id: Number(variant.id),
            quantity: pricingMetrics.cartQuantity,
            properties: variantRecipeProperties(form)
          }],
          adjustmentItems: [],
          adjustmentCents: 0,
          dollarQuantity: 0,
          centQuantity: 0
        };
      }
      return window.ZugBannerPricing.buildAdjustmentBundle({
        uid: state.configUid,
        totalCents: pricingMetrics.totalCents,
        basePriceCents: Number(variant.price),
        baseVariantId: Number(variant.id),
        dollarVariantId: adjustmentVariants && adjustmentVariants.dollar,
        centVariantId: adjustmentVariants && adjustmentVariants.cent,
        baseProperties: variantRecipeProperties(form)
      });
    }

    function rollbackLine(lineKey) {
      if (!lineKey) return Promise.resolve();
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).catch(function (error) {
        console.error('[ZUG Banner Recipe] Failed to roll back an incomplete artwork line.', error);
      });
    }

    function addUploadedArtworkLine(variant, bundle) {
      var formData = new FormData(form);
      formData.set('id', String(variant.id));
      formData.set('quantity', String(bundle.items[0].quantity));

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (response) {
        if (!response.ok) {
          return variantRecipeResponseError(response, 'The configured ' + recipeTitle + ' could not be added.');
        }
        return response.json();
      }).then(function (line) {
        if (!line.properties || !line.properties['_Artwork File']) {
          return rollbackLine(line.key).then(function () {
            throw new Error('Shopify did not retain the artwork file property.');
          });
        }
        if (bundle.adjustmentItems.length === 0) return line;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: bundle.adjustmentItems })
        }).then(function (response) {
          if (!response.ok) {
            return variantRecipeResponseError(response, 'The selected turnaround price could not be added.')
              .catch(function (error) {
                return rollbackLine(line.key).then(function () { throw error; });
              });
          }
          return response.json();
        });
      });
    }

    function addUploadLaterLine(bundle) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: bundle.items })
      }).then(function (response) {
        if (!response.ok) {
          return variantRecipeResponseError(response, 'The configured ' + recipeTitle + ' could not be added.');
        }
        return response.json();
      });
    }

    function verifyNativeCartLine(addResult, bundle) {
      if (!requiresNativeTurnaround) return Promise.resolve(addResult);
      var submittedKeys = [];
      if (addResult && addResult.key) submittedKeys.push(addResult.key);
      if (addResult && Array.isArray(addResult.items)) {
        addResult.items.forEach(function (item) {
          if (item && item.key) submittedKeys.push(item.key);
        });
      }

      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart verification failed.');
          return response.json();
        })
        .then(function (cart) {
          var matches = cart.items.filter(function (item) {
            return item.properties && item.properties._calc_line_uid === state.configUid;
          });
          var line = matches[0];
          var expected = bundle.items[0];
          var valid = matches.length === 1 &&
            Number(line.id) === Number(expected.id) &&
            Number(line.quantity) === Number(expected.quantity) &&
            Number(line.final_line_price) === Number(state.pricingMetrics.totalCents) &&
            line.properties._pricing_engine == null &&
            line.properties._line_type == null;
          if (valid) return addResult;

          var rollbackLines = matches.length > 0
            ? matches
            : cart.items.filter(function (item) { return submittedKeys.indexOf(item.key) !== -1; });
          return Promise.all(rollbackLines.map(function (item) {
            return rollbackLine(item.key);
          })).then(function () {
            throw new Error('Shopify Cart did not retain the exact native Step and Repeat line.');
          });
        });
    }

    function attemptCartSubmission() {
      if (!render() || !state.artworkMode || !state.selectedVariant) {
        if (!state.artworkMode) setStatus('Choose Upload Artwork or Upload Later before adding to cart.', true);
        return;
      }

      var bundle;
      try {
        bundle = buildVariantRecipeBundle();
      } catch (error) {
        console.error('[ZUG Banner Recipe] Pricing failed.', error);
        setStatus('This product cannot be configured for online ordering right now. Please contact us for assistance.', true);
        return;
      }

      isSubmitting = true;
      submitButton.setAttribute('aria-busy', 'true');
      render();
      setStatus('Adding your ' + recipeTitle + ' to cart…');

      var addPromise = state.artworkMode === 'upload_artwork'
        ? addUploadedArtworkLine(state.selectedVariant, bundle)
        : addUploadLaterLine(bundle);

      addPromise
        .then(function (addResult) {
          return verifyNativeCartLine(addResult, bundle);
        })
        .then(function () {
          setStatus('');
          state.configUid = configUid();
          return variantRecipeRefreshCart();
        })
        .catch(function (error) {
          console.error('[ZUG Banner Recipe] Add to cart failed.', error);
          setStatus('Your ' + recipeTitle + ' could not be added. Please try again or contact us for assistance.', true);
        })
        .finally(function () {
          isSubmitting = false;
          submitButton.removeAttribute('aria-busy');
          render();
        });
    }

    groupConfigs.forEach(function (groupConfig) {
      groupConfig.buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          state.selections[groupConfig.optionName] = button.dataset.optionValue;
          render();
        });
      });
    });

    addonModalConfigs.forEach(function (modalConfig) {
      modalConfig.trigger.addEventListener('click', function () { openAddonModal(modalConfig); });
      modalConfig.cards.forEach(function (card) {
        card.addEventListener('click', function () {
          modalConfig.tempAddons[card.dataset.group] = card.dataset.key;
          renderAddonModal(modalConfig);
        });
      });
      if (modalConfig.apply) {
        modalConfig.apply.addEventListener('click', function () {
          Object.keys(modalConfig.tempAddons).forEach(function (key) {
            state.addons[key] = modalConfig.tempAddons[key];
          });
          closeAddonModal(modalConfig);
          render();
        });
      }
      modalConfig.closeButtons.forEach(function (button) {
        button.addEventListener('click', function () { closeAddonModal(modalConfig); });
      });
      if (modalConfig.modal) {
        modalConfig.modal.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeAddonModal(modalConfig);
            return;
          }
          if (event.key !== 'Tab') return;
          var focusables = focusableElements(modalConfig.modal);
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      }
    });

    turnaroundButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        turnaroundButtons.forEach(function (choice) {
          var selected = choice === button;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        state.turnaround = button.dataset.value;
        state.turnaroundLabel = button.dataset.label;
        if (requiresNativeTurnaround) {
          state.selections[nativeTurnaroundOption] = nativeTurnaroundValues[state.turnaround] || '';
        }
        state.turnaroundMultiplier = state.turnaround === 'rush_3_5'
          ? 1.2
          : state.turnaround === 'rush_1_2' ? 1.5 : 1;
        turnaroundValue.textContent = state.turnaroundLabel;
        updateVariantRecipeTimeline();
        render();
      });
    });

    if (quantityMode === 'variant-tier') {
      if (quantityMinus) {
        quantityMinus.addEventListener('click', function () { adjustTierQuantity(-1); });
      }
      if (quantityPlus) {
        quantityPlus.addEventListener('click', function () { adjustTierQuantity(1); });
      }
      tierQuantityDisplay.addEventListener('input', render);
      tierQuantityDisplay.addEventListener('change', render);
    } else {
      quantityInput.addEventListener('input', render);
      quantityInput.addEventListener('change', render);
    }
    submitButton.addEventListener('click', function (event) {
      if (!render()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); });

    if (modal) {
      modal.addEventListener('zug-banner:artwork-saved', function (event) {
        state.artworkMode = event.detail.mode;
        state.artworkLabel = event.detail.label;
        setProperty('Artwork', event.detail.label);
        setProperty('_banner_artwork_mode', event.detail.mode);
        render();
        attemptCartSubmission();
      });
    }

    render();
    if (requiresNativeTurnaround) return;
    fetch(root.dataset.variantMapUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Store pricing configuration could not be loaded.');
        return response.json();
      })
      .then(function (variantMap) {
        adjustmentVariants = variantMap && variantMap.adjustment ? {
          dollar: variantMap.adjustment.dollar || variantMap.adjustment.Dollar,
          cent: variantMap.adjustment.cent || variantMap.adjustment.Cent
        } : null;
        if (!adjustmentVariants || !adjustmentVariants.dollar || !adjustmentVariants.cent) {
          adjustmentVariants = null;
          throw new Error('Adjustment variants are not configured.');
        }
        render();
      })
      .catch(function (error) {
        console.error('[ZUG Banner Recipe] Turnaround pricing initialization failed.', error);
        render();
        setStatus('This product cannot be configured for online ordering right now. Please contact us for assistance.', true);
      });
  }

  function initializeCalculator(root) {
    if (root.dataset.zugBannerCalculatorReady === 'true') return;
    root.dataset.zugBannerCalculatorReady = 'true';

    if (root.dataset.recipeType === 'variant') {
      initializeVariantRecipe(root);
      return;
    }

    var status = root.querySelector('[data-zug-banner-status]');
    if (!window.ZugBannerPricing) {
      status.textContent = 'Banner pricing could not initialize.';
      return;
    }

    var form = document.getElementById(root.dataset.formId);
    var submitButton = root.querySelector('[data-zug-banner-submit]');
    var dimensionErrors = root.querySelector('[data-zug-banner-dimension-errors]');
    var quantityError = root.querySelector('[data-zug-banner-quantity-error]');
    var sizeChoices = root.querySelector('[data-zug-banner-size-choices]');
    var customSize = root.querySelector('[data-zug-banner-custom-size]');
    var quantityInput = root.querySelector('[data-zug-banner-quantity-input]');
    var quantityMinus = root.querySelector('[data-zug-banner-quantity-minus]');
    var sizeValue = root.querySelector('[data-zug-banner-size-value]');
    var turnaroundValue = root.querySelector('[data-zug-banner-turnaround-value]');
    var materialLinks = Array.from(root.querySelectorAll('[data-zug-banner-material-link]'));
    var initialSizeButton = sizeChoices.querySelector('.is-selected[data-width-in]');
    var finishingSummary = root.querySelector('[data-zug-banner-finishing-summary]');
    var finishingTrigger = root.querySelector('[data-zug-banner-finishing-open]');
    var finishingModal = document.getElementById(root.dataset.finishingModalId);
    var finishingCards = Array.from(finishingModal.querySelectorAll('[data-zug-banner-modal-option]'));
    var finishingApply = finishingModal.querySelector('[data-zug-banner-finishing-apply]');
    var finishingModalSummary = finishingModal.querySelector('[data-zug-banner-finishing-modal-summary]');
    var finishingCloseButtons = Array.from(finishingModal.querySelectorAll('[data-zug-banner-finishing-close]'));
    var finishingOpener = null;
    var config = null;
    var adjustmentVariants = null;
    var materialResolution = null;
    var latestPricing = null;
    var tempFinishingState = null;

    function cardFor(group, key) {
      return finishingCards.find(function (card) {
        return card.dataset.group === group && card.dataset.key === key;
      });
    }

    function firstCardFor(group) {
      return finishingCards.find(function (card) { return card.dataset.group === group; });
    }

    function labelFor(group, key) {
      var card = cardFor(group, key) || firstCardFor(group);
      return card ? card.dataset.label : key;
    }

    var state = {
      sizeKey: initialSizeButton.dataset.sizeKey,
      widthInches: Number(initialSizeButton.dataset.widthIn),
      heightInches: Number(initialSizeButton.dataset.heightIn),
      quantity: 1,
      finishing: cardFor('finishing', 'hemmed_and_grommets') ? 'hemmed_and_grommets' :
        (firstCardFor('finishing') ? firstCardFor('finishing').dataset.key : 'none'),
      polePockets: cardFor('polePockets', 'none') ? 'none' :
        (firstCardFor('polePockets') ? firstCardFor('polePockets').dataset.key : 'none'),
      windSlits: cardFor('windSlits', 'no') ? 'no' : (firstCardFor('windSlits') ? firstCardFor('windSlits').dataset.key : 'no'),
      windSlitsSupported: root.dataset.windSlitsSupported === 'true',
      turnaround: 'regular',
      turnaroundLabel: turnaroundValue ? turnaroundValue.textContent.trim() : 'Regular',
      artworkMode: '',
      configUid: configUid()
    };

    function setStatus(message, isError) {
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function propertyInput(name) {
      return form.querySelector('[data-property="' + name + '"]');
    }

    function setProperty(name, value) {
      var input = propertyInput(name);
      if (input) input.value = value == null ? '' : String(value);
    }

    function normalizedDimensions() {
      if (state.sizeKey !== 'custom') return { width: state.widthInches, height: state.heightInches, valid: true };

      var widthFeet = number(customSize.querySelector('[data-dimension="width-feet"]').value, NaN);
      var widthExtraInches = number(customSize.querySelector('[data-dimension="width-inches"]').value, NaN);
      var heightFeet = number(customSize.querySelector('[data-dimension="height-feet"]').value, NaN);
      var heightExtraInches = number(customSize.querySelector('[data-dimension="height-inches"]').value, NaN);
      var errors = [];

      if (!Number.isInteger(widthFeet) || widthFeet < 0) errors.push('Width feet must be a whole number of zero or greater.');
      if (!Number.isFinite(widthExtraInches) || widthExtraInches < 0) errors.push('Width inches must be zero or greater.');
      if (!Number.isInteger(heightFeet) || heightFeet < 0) errors.push('Height feet must be a whole number of zero or greater.');
      if (!Number.isFinite(heightExtraInches) || heightExtraInches < 0) errors.push('Height inches must be zero or greater.');

      var width = window.ZugBannerPricing.normalizeDimension(widthFeet, widthExtraInches);
      var height = window.ZugBannerPricing.normalizeDimension(heightFeet, heightExtraInches);
      var minWidth = number(root.dataset.minWidth, 12);
      var maxWidth = number(root.dataset.maxWidth, 1800);
      var minHeight = number(root.dataset.minHeight, 12);
      var maxHeight = number(root.dataset.maxHeight, 600);
      if (Number.isFinite(width) && !window.ZugBannerPricing.dimensionWithinLimits(width, minWidth, maxWidth)) {
        errors.push('Width must total between ' + trimNumber(minWidth, 2) + ' and ' + trimNumber(maxWidth, 2) + ' inches.');
      }
      if (Number.isFinite(height) && !window.ZugBannerPricing.dimensionWithinLimits(height, minHeight, maxHeight)) {
        errors.push('Height must total between ' + trimNumber(minHeight, 2) + ' and ' + trimNumber(maxHeight, 2) + ' inches.');
      }
      dimensionErrors.innerHTML = errors.map(function (message) { return '<div>' + message + '</div>'; }).join('');
      return { width: width, height: height, valid: errors.length === 0 };
    }

    function normalizedQuantity() {
      var value = number(quantityInput.value, NaN);
      var valid = Number.isInteger(value) && value >= 1;
      quantityInput.style.setProperty(
        '--quantity-input-characters-count',
        Math.max(String(quantityInput.value || '1').length, 1) + 'ch'
      );
      quantityError.textContent = valid ? '' : 'Quantity must be a whole number of at least 1.';
      quantityInput.setAttribute('aria-invalid', valid ? 'false' : 'true');
      quantityMinus.disabled = valid && value <= 1;
      return { quantity: value, valid: valid };
    }

    function validate() {
      var dimensions = normalizedDimensions();
      var quantity = normalizedQuantity();
      if (dimensions.valid) {
        state.widthInches = dimensions.width;
        state.heightInches = dimensions.height;
      }
      if (quantity.valid) state.quantity = quantity.quantity;
      return dimensions.valid && quantity.valid;
    }

    function optionSummary(source, includePocketSuffix) {
      var parts = [labelFor('finishing', source.finishing)];
      var pocketLabel = labelFor('polePockets', source.polePockets);
      if (source.polePockets === 'none') {
        parts.push(includePocketSuffix ? 'No Pole Pockets' : 'None');
      } else {
        parts.push(includePocketSuffix ? pocketLabel + ' Pole Pockets' : pocketLabel);
      }
      if (state.windSlitsSupported) parts.push(source.windSlits === 'yes' ? 'Wind Slits' : 'No Wind Slits');
      return parts.join(' · ');
    }

    function renderAppliedFinishing() {
      finishingSummary.textContent = optionSummary(state, true);
    }

    function renderModalState() {
      finishingCards.forEach(function (card) {
        var selected = tempFinishingState[card.dataset.group] === card.dataset.key;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      finishingModalSummary.textContent = optionSummary(tempFinishingState, false);
    }

    function closeFinishingModal() {
      finishingModal.hidden = true;
      finishingModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      tempFinishingState = null;
      if (finishingOpener && typeof finishingOpener.focus === 'function') finishingOpener.focus();
    }

    function openFinishingModal(event) {
      finishingOpener = event.currentTarget;
      tempFinishingState = {
        finishing: state.finishing,
        polePockets: state.polePockets,
        windSlits: state.windSlits
      };
      renderModalState();
      finishingModal.hidden = false;
      finishingModal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var selected = finishingModal.querySelector('.zug-banner-finishing-card.is-selected');
      (selected || focusableElements(finishingModal)[0]).focus();
    }

    function updateTimelineRange() {
      var timeline = document.getElementById('ptl-' + root.id.replace('zug-banner-calculator-', '') + '-banner-calc');
      if (!timeline || typeof timeline.ptlSetRange !== 'function') return;
      var min = Number(timeline.dataset.minDays) || 4;
      var max = Number(timeline.dataset.maxDays) || 7;
      if (state.turnaround === 'rush_3_5') {
        min = 3;
        max = 5;
      } else if (state.turnaround === 'rush_1_2') {
        min = 1;
        max = 2;
      }
      timeline.ptlSetRange(min, max);
    }

    function updateMaterialLinks() {
      materialLinks.forEach(function (link) {
        if (link.getAttribute('aria-current') === 'page') return;
        var destination = new URL(link.getAttribute('href'), window.location.origin);
        destination.search = '';
        destination.searchParams.set('width_in', trimNumber(state.widthInches, 2));
        destination.searchParams.set('height_in', trimNumber(state.heightInches, 2));
        destination.searchParams.set('quantity', String(state.quantity));
        destination.searchParams.set('finishing', URL_FINISHING_VALUES[state.finishing]);
        destination.searchParams.set('pole_pockets', URL_POLE_POCKET_VALUES[state.polePockets]);
        destination.searchParams.set('turnaround', state.turnaround);
        if (state.windSlitsSupported && link.dataset.supportsWindSlits === 'true') {
          destination.searchParams.set('wind_slits', state.windSlits);
        }
        link.href = destination.pathname + destination.search;
      });
    }

    function updateProperties() {
      setProperty('Size', sizeLabel(state.widthInches, state.heightInches));
      setProperty('Width', trimNumber(state.widthInches, 2) + ' in');
      setProperty('Height', trimNumber(state.heightInches, 2) + ' in');
      setProperty('Finishing', labelFor('finishing', state.finishing));
      setProperty('Pole Pockets', labelFor('polePockets', state.polePockets));
      setProperty('Turnaround', state.turnaroundLabel);
      setProperty('Quantity', state.quantity);
      setProperty('_banner_config_version', config ? config.version : '');
      setProperty('_banner_width_in', trimNumber(state.widthInches, 4));
      setProperty('_banner_height_in', trimNumber(state.heightInches, 4));
      setProperty('_banner_finishing_key', state.finishing);
      setProperty('_banner_pole_pockets_key', state.polePockets);
      setProperty('_banner_turnaround_key', state.turnaround);
      setProperty('_banner_config_uid', state.configUid);
      setProperty('_banner_material_key', materialResolution && materialResolution.valid ? materialResolution.key : '');
      setProperty('calc_line_uid', state.configUid);
      setProperty('_bundle_display_quantity', state.quantity);
      if (state.windSlitsSupported) {
        setProperty('Wind Slits', state.windSlits === 'yes' ? 'Yes' : 'No');
        setProperty('_banner_wind_slits', state.windSlits);
      }
      if (latestPricing) {
        setProperty('Square Feet per Banner', trimNumber(latestPricing.squareFeetPerBanner, 4) + ' sq ft');
        setProperty('Total Square Feet', trimNumber(latestPricing.totalOrderSquareFeet, 4) + ' sq ft');
        setProperty('_banner_sq_ft_each', trimNumber(latestPricing.squareFeetPerBanner, 6));
        setProperty('_banner_total_sq_ft', trimNumber(latestPricing.totalOrderSquareFeet, 6));
        setProperty('_banner_interpolated_rate', trimNumber(latestPricing.interpolatedRate, 6));
        setProperty('_banner_expected_total_cents', latestPricing.totalPriceCents);
        setProperty('_total_desired', (latestPricing.totalPriceCents / 100).toFixed(2));
      }
    }

    function updateSummary() {
      var readableSize = sizeLabel(state.widthInches, state.heightInches);
      sizeValue.textContent = readableSize;
      root.querySelector('[data-summary="quantity"]').textContent = String(state.quantity);
      root.querySelector('[data-summary="size"]').textContent = readableSize;
      root.querySelector('[data-summary="priceEach"]').textContent =
        latestPricing ? currency(latestPricing.pricePerBanner, config.currency) : '—';
      root.querySelector('[data-summary="totalPrice"]').textContent =
        latestPricing ? currency(latestPricing.totalPrice, config.currency) : 'Unavailable';
    }

    function recalculate() {
      var valid = validate();
      latestPricing = null;
      var materialPricingReady = config &&
        materialResolution &&
        materialResolution.valid &&
        materialResolution.recipe &&
        materialResolution.recipe.pricing_key === config.pricing_key;
      if (valid && config && materialPricingReady) {
        try {
          latestPricing = window.ZugBannerPricing.calculate(config, state, materialResolution.recipe);
          setStatus('');
        } catch (error) {
          setStatus(error.message, true);
        }
      }
      updateSummary();
      updateProperties();
      if (valid) updateMaterialLinks();
      return valid && Boolean(latestPricing);
    }

    function chooseSize(button) {
      state.sizeKey = button.dataset.sizeKey;
      sizeChoices.querySelectorAll('[data-size-key]').forEach(function (choice) {
        var selected = choice === button;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      customSize.hidden = state.sizeKey !== 'custom';
      if (state.sizeKey !== 'custom') {
        state.widthInches = Number(button.dataset.widthIn);
        state.heightInches = Number(button.dataset.heightIn);
      }
      recalculate();
    }

    function applyQueryState() {
      var params = new URLSearchParams(window.location.search);
      var recognized = ['width_in', 'height_in', 'quantity', 'finishing', 'pole_pockets', 'turnaround', 'wind_slits'];
      if (!recognized.some(function (key) { return params.has(key); })) return;

      var width = number(params.get('width_in'), NaN);
      var height = number(params.get('height_in'), NaN);
      if (width >= number(root.dataset.minWidth, 12) && width <= number(root.dataset.maxWidth, 1800) &&
          height >= number(root.dataset.minHeight, 12) && height <= number(root.dataset.maxHeight, 600)) {
        var preset = Array.from(sizeChoices.querySelectorAll('[data-width-in]')).find(function (button) {
          return Number(button.dataset.widthIn) === width && Number(button.dataset.heightIn) === height;
        });
        var sizeButton = preset || sizeChoices.querySelector('[data-size-key="custom"]');
        chooseSize(sizeButton);
        if (!preset) {
          customSize.querySelector('[data-dimension="width-feet"]').value = '0';
          customSize.querySelector('[data-dimension="width-inches"]').value = trimNumber(width, 2);
          customSize.querySelector('[data-dimension="height-feet"]').value = '0';
          customSize.querySelector('[data-dimension="height-inches"]').value = trimNumber(height, 2);
        }
      }

      var quantity = number(params.get('quantity'), NaN);
      if (Number.isInteger(quantity) && quantity >= 1) quantityInput.value = String(quantity);

      var finishing = canonicalKey(params.get('finishing'));
      if (finishing === 'hemmed_grommets') finishing = 'hemmed_and_grommets';
      if (FINISHING_KEYS.indexOf(finishing) !== -1 && cardFor('finishing', finishing)) state.finishing = finishing;
      var pockets = canonicalKey(params.get('pole_pockets'));
      if (POLE_POCKET_KEYS.indexOf(pockets) !== -1 && cardFor('polePockets', pockets)) state.polePockets = pockets;
      var wind = canonicalKey(params.get('wind_slits'));
      if (state.windSlitsSupported && ['yes', 'no'].indexOf(wind) !== -1 && cardFor('windSlits', wind)) state.windSlits = wind;

      var turnaround = canonicalKey(params.get('turnaround'));
      var turnaroundGroup = root.querySelector('[data-zug-banner-choice-group="turnaround"]');
      if (turnaroundGroup && ['regular', 'rush_3_5', 'rush_1_2'].indexOf(turnaround) !== -1) {
        var turnaroundButton = turnaroundGroup.querySelector('[data-value="' + turnaround + '"]');
        if (turnaroundButton) {
          state.turnaround = turnaround;
          state.turnaroundLabel = turnaroundButton.dataset.label;
          turnaroundValue.textContent = state.turnaroundLabel;
          turnaroundGroup.querySelectorAll('[data-value]').forEach(function (button) {
            var selected = button === turnaroundButton;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        }
      }
      renderAppliedFinishing();
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.hash);
    }

    function submissionDiagnostic() {
      return {
        mode: config && config.shopify_submission ? config.shopify_submission.mode : '(pricing config unavailable)',
        materialTagKey: materialResolution && materialResolution.key ? materialResolution.key : '(missing or unsupported)',
        materialPricingKey: materialResolution && materialResolution.recipe ? materialResolution.recipe.pricing_key : '(unresolved)',
        loadedPricingKey: config && config.pricing_key ? config.pricing_key : '(missing)',
        dollarAdjustmentVariantId: adjustmentVariants && adjustmentVariants.dollar ? adjustmentVariants.dollar : '(missing)',
        centAdjustmentVariantId: adjustmentVariants && adjustmentVariants.cent ? adjustmentVariants.cent : '(missing)',
        variantMapUrl: root.dataset.variantMapUrl || '(missing)'
      };
    }

    function logSubmissionDiagnostic(message) {
      if (window.console && typeof window.console.warn === 'function') {
        console.warn('[ZUG Banner] ' + message, submissionDiagnostic());
      }
    }

    function customerConfigurationFailure() {
      setStatus('This product cannot be configured for online ordering right now. Please contact us for assistance.', true);
    }

    function responseError(response, fallback) {
      return response.json()
        .catch(function () { return {}; })
        .then(function (payload) {
          throw new Error(payload.description || payload.message || fallback);
        });
    }

    function propertiesFromForm() {
      var properties = {};
      var formData = new FormData(form);
      formData.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (!match || (typeof File !== 'undefined' && value instanceof File)) return;
        if (String(value).trim() !== '') properties[match[1]] = String(value);
      });
      return properties;
    }

    function buildBundle() {
      return window.ZugBannerPricing.buildAdjustmentBundle({
        uid: state.configUid,
        totalCents: latestPricing.totalPriceCents,
        basePriceCents: number(root.dataset.variantPriceCents, NaN),
        baseVariantId: number(root.dataset.baseVariantId, NaN),
        dollarVariantId: adjustmentVariants && adjustmentVariants.dollar,
        centVariantId: adjustmentVariants && adjustmentVariants.cent,
        baseProperties: propertiesFromForm()
      });
    }

    function refreshCartAndOpenDrawer() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed.');
          return response.json();
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.setTimeout(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') drawer.show();
          }, 300);
        });
    }

    function addEmailLaterBundle(bundle) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: bundle.items })
      }).then(function (response) {
        if (!response.ok) return responseError(response, 'The configured banner could not be added to cart.');
        return response.json();
      });
    }

    function rollbackBaseLine(lineKey) {
      if (!lineKey) return Promise.resolve();
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).catch(function (error) {
        console.error('[ZUG Banner] Failed to roll back an incomplete upload bundle.', error);
      });
    }

    function addUploadBundle(bundle) {
      var baseFormData = new FormData(form);
      baseFormData.set('id', String(root.dataset.baseVariantId));
      baseFormData.set('quantity', '1');

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: baseFormData
      }).then(function (response) {
        if (!response.ok) return responseError(response, 'The artwork file could not be attached.');
        return response.json();
      }).then(function (baseLine) {
        if (!baseLine.properties || !baseLine.properties['_Artwork File']) {
          return rollbackBaseLine(baseLine.key).then(function () {
            throw new Error('Shopify did not retain the artwork file property.');
          });
        }
        if (bundle.adjustmentItems.length === 0) return baseLine;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: bundle.adjustmentItems })
        }).then(function (response) {
          if (!response.ok) {
            return responseError(response, 'The configured price could not be added.')
              .catch(function (error) {
                return rollbackBaseLine(baseLine.key).then(function () { throw error; });
              });
          }
          return response.json();
        });
      });
    }

    function attemptCartSubmission() {
      if (!recalculate()) {
        logSubmissionDiagnostic('Submission blocked because pricing or material configuration is invalid.');
        customerConfigurationFailure();
        return;
      }

      var submissionMode = config && config.shopify_submission && config.shopify_submission.mode;
      if (submissionMode !== 'adjustment_bundle' ||
          !adjustmentVariants || !adjustmentVariants.dollar || !adjustmentVariants.cent) {
        logSubmissionDiagnostic('Submission blocked because the adjustment bundle is not configured.');
        customerConfigurationFailure();
        return;
      }

      var bundle;
      try {
        bundle = buildBundle();
      } catch (error) {
        console.error('[ZUG Banner] Bundle validation failed.', error, submissionDiagnostic());
        customerConfigurationFailure();
        return;
      }

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      setStatus('Adding your configured banner to cart…');

      var addPromise = state.artworkMode === 'upload_artwork'
        ? addUploadBundle(bundle)
        : addEmailLaterBundle(bundle);

      addPromise
        .then(function () {
          setStatus('');
          state.configUid = configUid();
          updateProperties();
          return refreshCartAndOpenDrawer();
        })
        .catch(function (error) {
          console.error('[ZUG Banner] Add to cart failed.', error, submissionDiagnostic());
          setStatus('Your configured banner could not be added. Please try again or contact us for assistance.', true);
        })
        .finally(function () {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        });
    }

    sizeChoices.querySelectorAll('[data-size-key]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
      button.addEventListener('click', function () { chooseSize(button); });
    });
    customSize.querySelectorAll('input').forEach(function (input) { input.addEventListener('input', recalculate); });
    quantityInput.addEventListener('input', recalculate);
    quantityInput.addEventListener('change', recalculate);

    finishingTrigger.addEventListener('click', openFinishingModal);
    finishingCards.forEach(function (card) {
      card.addEventListener('click', function () {
        tempFinishingState[card.dataset.group] = card.dataset.key;
        renderModalState();
      });
    });
    finishingApply.addEventListener('click', function () {
      state.finishing = tempFinishingState.finishing;
      state.polePockets = tempFinishingState.polePockets;
      if (state.windSlitsSupported) state.windSlits = tempFinishingState.windSlits;
      renderAppliedFinishing();
      closeFinishingModal();
      recalculate();
    });
    finishingCloseButtons.forEach(function (button) { button.addEventListener('click', closeFinishingModal); });
    finishingModal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFinishingModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusables = focusableElements(finishingModal);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    root.querySelectorAll('[data-zug-banner-choice-group="turnaround"] [data-value]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
      button.addEventListener('click', function () {
        var group = button.closest('[data-zug-banner-choice-group]');
        group.querySelectorAll('[data-value]').forEach(function (choice) {
          var selected = choice === button;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        state.turnaround = button.dataset.value;
        state.turnaroundLabel = button.dataset.label;
        turnaroundValue.textContent = state.turnaroundLabel;
        updateTimelineRange();
        recalculate();
      });
    });

    submitButton.addEventListener('click', function (event) {
      if (!recalculate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!materialResolution || !materialResolution.valid ||
            !config || !materialResolution.recipe ||
            materialResolution.recipe.pricing_key !== config.pricing_key) {
          logSubmissionDiagnostic('Artwork dialog blocked because material pricing is unavailable.');
          customerConfigurationFailure();
        } else {
          setStatus('Correct the highlighted size or quantity fields before continuing.', true);
        }
      }
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    document.addEventListener('zug-banner:artwork-saved', function (event) {
      if (event.target.id !== root.dataset.modalId) return;
      state.artworkMode = event.detail.mode;
      setProperty('Artwork', event.detail.label);
      setProperty('Artwork File', event.detail.filename || '');
      setProperty('_banner_artwork_mode', event.detail.mode);
      attemptCartSubmission();
    });

    renderAppliedFinishing();
    Promise.all([
      fetch(root.dataset.pricingUrl, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Banner pricing configuration could not be loaded.');
        return response.json();
      }),
      fetch(root.dataset.variantMapUrl, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Store pricing configuration could not be loaded.');
        return response.json();
      })
    ])
      .then(function (loaded) {
        window.ZugBannerPricing.validateConfig(loaded[0]);
        config = loaded[0];
        adjustmentVariants = loaded[1] && loaded[1].adjustment ? {
          dollar: loaded[1].adjustment.dollar || loaded[1].adjustment.Dollar,
          cent: loaded[1].adjustment.cent || loaded[1].adjustment.Cent
        } : null;
        materialResolution = window.ZugBannerPricing.resolveMaterialTag(
          String(root.dataset.productTags || '').split('||'),
          config.material_recipes
        );

        if (!materialResolution.valid ||
            materialResolution.key !== root.dataset.materialKey ||
            root.dataset.materialValid !== 'true') {
          logSubmissionDiagnostic('A supported authoritative ZUG_MAT tag was not resolved consistently.');
        } else {
          state.windSlitsSupported = Boolean(materialResolution.recipe.allow_wind_slits);
        }

        applyQueryState();
        renderAppliedFinishing();
        recalculate();
        if (!latestPricing || !adjustmentVariants || !adjustmentVariants.dollar || !adjustmentVariants.cent) {
          logSubmissionDiagnostic('Banner configuration loaded in a fail-closed state.');
          if (window.Shopify && Shopify.designMode) {
            setStatus('Theme Editor: banner ordering is unavailable. See the console for the exact configuration issue.', true);
          }
        }
      })
      .catch(function (error) {
        console.error('[ZUG Banner] Initialization failed.', error, submissionDiagnostic());
        if (window.Shopify && Shopify.designMode) {
          setStatus('Theme Editor: banner configuration could not initialize. See the console for details.', true);
        }
        updateSummary();
      });
  }

  function initializeAll() {
    document.querySelectorAll('[data-zug-banner-calculator]').forEach(initializeCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
